import { render, staticRenderFns } from "./wxUserManage.vue?vue&type=template&id=807c1dbe"
import script from "./wxUserManage.vue?vue&type=script&lang=js"
export * from "./wxUserManage.vue?vue&type=script&lang=js"
import style0 from "./wxUserManage.vue?vue&type=style&index=0&id=807c1dbe&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports